import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import eachMonthOfInterval from 'date-fns/eachMonthOfInterval';
import eachYearOfInterval from 'date-fns/eachYearOfInterval';
import format from 'date-fns/format';

export type DatePickerInterval = 'year' | 'month' | 'day' | 'time';

export const generateDates = (
  start: Date,
  end: Date,
  interval: DatePickerInterval
) => {
  const payload = { start, end };
  let dates: Date[] = [];
  if (interval === 'year') dates = eachYearOfInterval(payload);
  else if (interval === 'month') dates = eachMonthOfInterval(payload);
  else dates = eachDayOfInterval(payload);

  return dates.reverse();
};

interface FormatDateOptions {
  dateFormat?: string;
  interval?: DatePickerInterval;
}

export const formatDate = (
  date: Date,
  { dateFormat, interval }: FormatDateOptions
) => {
  if (dateFormat) return format(date, dateFormat);
  if (interval === 'year') return format(date, 'yyyy');
  if (interval === 'month') return format(date, 'MMMM');
  return format(date, 'dd');
};
